import { getBaseInsuranceEligibilityEventAttributes } from '@/types/insurance-builder.type';
import type { InsuranceEligibilityFailReason } from '@/views/insurance/terminal/ineligible-waitlist/InsuranceIneligible';

import { trackCioEvent } from '../cio';
import { AnalyticsEvent } from '../types';

export type EligibilityCheckpointEventProperties = ReturnType<
  typeof getBaseInsuranceEligibilityEventAttributes
> & {
  eligibility_fail_reason?: InsuranceEligibilityFailReason;
};

export function trackEligibilityCheckpoint(properties: EligibilityCheckpointEventProperties) {
  trackCioEvent(AnalyticsEvent.ELIGIBILITY_CHECKPOINT, properties);
}
